const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100]

export default {
  PAGE_SIZE_OPTIONS
}
